<template>
  <div>
    <q-form-item :prop="element.key">
      <!--      <upload-tr-->
      <!--        v-model="model[element.key]"-->
      <!--        :disabled="element.disabled"-->
      <!--        note=""></upload-tr>-->
    </q-form-item>
  </div>
</template>

<script>
  import elementGeneratorMixin from "./elementGeneratorMixin";

  export default {
    name: "UploadItem",
    mixins: [elementGeneratorMixin],
  }
</script>

<style scoped>

</style>